module.exports = __webpack_public_path__ + "img/196-tajikistan.18657b24.svg";